import React from "react";
import NewTooltip from "../Tooltip/NewTooltip";

type inputProps = {
  name: string;
  title: string;
  required?: boolean;
  disabled?: boolean;
  error?: boolean;
  tooltip?: string;
  labelClass?: string;
};

const InputLabel: React.FC<inputProps> = ({
  name,
  title,
  required,
  error,
  disabled,
  tooltip,
  labelClass,
}) => {
  const labelColorClass = disabled 
    ? "text-gray-200" 
    : error 
    ? "text-primary" 
    : "text-gray-font";

  return (
    <div className="flex w-full items-center gap-2">
      {title && (
        <label
          htmlFor={name}
          className={`${labelClass} text-base md:text-lg font-medium ${labelColorClass}`}
        >
          {title} {required && <span className="text-primary"> *</span>}
        </label>
      )}
      {tooltip && <NewTooltip text={tooltip} />}
    </div>
  );
};

export default InputLabel;
